import { useMutation } from 'react-query';

import { useCompany } from 'modules/app/hooks/useCompany';
import { postV2ApiCompanyIdRequestsApprovals } from 'src/client/spendesk-api';
import { type PostV2ApiCompanyIdRequestsApprovalsResponseOK } from 'src/client/spendesk-api-types';

export type RequestsApprovals =
  PostV2ApiCompanyIdRequestsApprovalsResponseOK['data'];

export const useRequestsApprovalsMutation = () => {
  const company = useCompany();
  return useMutation(
    ['v2', 'requests', 'approvals'],
    async (
      requestIds: string[],
    ): Promise<PostV2ApiCompanyIdRequestsApprovalsResponseOK> => {
      const response = await postV2ApiCompanyIdRequestsApprovals({
        path: {
          companyId: company.id,
        },
        body: {
          requestIds,
        },
      });

      if (response.statusCode !== 200) {
        throw new Error('Failed to approve requests');
      }
      return response.body;
    },
    {
      retry: false,
    },
  );
};
